import React from 'react';
import { ProgressLoadingBar } from '@ohif/ui-next';
import { LoadingMark } from './BrandIcons/LoadingMark';

// Drop-in for OHIF's LoadingIndicatorProgress (platform/ui-next ...
// /LoadingIndicatorProgress.tsx). Registered under `ui.loadingIndicatorProgress`
// (extensions/default loadingIndicatorProgressCustomization.tsx) so every loader —
// viewer, worklist, local, microscopy — shows the Sycai mark instead of
// <Icons.LoadingOHIFMark/>. The { className, textBlock, progress } props and wrapper
// layout mirror that component; a signature change upstream would render this with
// mismatched props. ProgressLoadingBar is imported directly, as upstream does, so the
// loader has no useSystem() context dependency (WorkList renders it outside that tree).
type SycaiLoadingIndicatorProps = {
  className?: string;
  textBlock?: React.ReactNode;
  progress?: number;
};

export function SycaiLoadingIndicator({
  className,
  textBlock,
  progress,
}: SycaiLoadingIndicatorProps) {
  return (
    <div
      className={[
        'absolute top-0 left-0 z-50 flex flex-col items-center justify-center space-y-5',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <LoadingMark />
      <div className="w-48">
        <ProgressLoadingBar progress={progress} />
      </div>
      {textBlock}
    </div>
  );
}

export default SycaiLoadingIndicator;
